module.exports = __webpack_public_path__ + "img/logo.c305c7a3.png";